import { useCallback } from "react";
import { useTrackingEvent } from "./useTrackingEvent";
import { useClassified } from "@/contexts/classified";
import { featureFlagsTracking } from "@/contexts/CdpProvider";
let hasFormInteractionFired = false;
export const resetFormInteractionTracking = () => {
    hasFormInteractionFired = false;
};
export const useTrackingFormInteraction = (tracking) => {
    var _a, _b;
    const { av_distribution_type_global, av_estate_type_global } = (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.tracking) !== null && _b !== void 0 ? _b : {};
    const EVENT_DATA = {
        event: "lead_classified_form_interaction",
        av_distribution_type_global,
        av_estate_type_global,
        av_zone: tracking === null || tracking === void 0 ? void 0 : tracking.avZone,
        av_ab_test_variant: featureFlagsTracking,
    };
    const trackEvent = useTrackingEvent(EVENT_DATA);
    const trackFormInteraction = useCallback(() => {
        if (!hasFormInteractionFired) {
            hasFormInteractionFired = true;
            trackEvent();
        }
    }, [trackEvent]);
    return { trackFormInteraction };
};
